"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const provider_1 = require("@cart/provider");
const alert_1 = require("@kawaui/alert");
const react_1 = require("react");
const styles_1 = require("./styles");
const mixpanel_1 = require("./utils/mixpanel");
const defaultI18n = (key) => key;
const IncompatibleDialog = ({ open, onClose, productId, quantity, cartType, i18n = defaultI18n, addtoCartCallback, track, newLoyalty, }) => {
    const { deleteCartConnected: deleteCart, addItemToCartConnected: addItem, addLoyaltyConnected: addLoyalty } = (0, provider_1.useCartActions)();
    (0, react_1.useEffect)(() => {
        if (open)
            track(...(0, mixpanel_1.IncompatibleCartRender)());
    }, [open]);
    const createNewCart = async () => {
        track(...(0, mixpanel_1.IncompatibleCartClickNewCart)());
        await deleteCart();
        const { status, data } = newLoyalty ? await addLoyalty(productId) : await addItem({ productId, quantity }, cartType);
        if (addtoCartCallback)
            addtoCartCallback(data, status);
    };
    const handleCancel = () => {
        track(...(0, mixpanel_1.IncompatibleCartClickNo)());
        onClose();
    };
    return ((0, jsx_runtime_1.jsxs)(alert_1.Alert, { open: open, onClose: onClose, children: [(0, jsx_runtime_1.jsxs)(alert_1.Header, { children: [" ", i18n('modal.cart.incompatibility.title')] }), (0, jsx_runtime_1.jsx)(alert_1.Content, { children: i18n('modal.cart.incompatibility.text') }), (0, jsx_runtime_1.jsx)(styles_1.ActionButton, { isFullWidth: true, isAsync: true, onClick: createNewCart, children: i18n('modal.cart.new_cart.button') }), (0, jsx_runtime_1.jsx)(styles_1.ActionButton, { isFullWidth: true, isAsync: true, variant: "tertiary", onClick: handleCancel, children: i18n('modal.cart.no_thanks.button') })] }));
};
exports.default = IncompatibleDialog;
